export function authHeaderEmptyContentType(): any {
    return {};
  
}

export function authHeader() {
  const headers = {} as any;
  headers['Content-Type'] = 'application/json';

  return headers;
}
